import { loadStripe } from '@stripe/stripe-js'
export const stripePromise = loadStripe(
  'pk_test_51SDaK62ZowwWnyTjpk8WzcYuXIlvZZlb7SQ8mCIYLOQgRn7lo4ey4run2TtV69YNAykasSsTwPr8gMsZJk8FwES700EmS1Gs8h'
)
